import type { ReactElement } from 'react';
import Banner from 'components/shared/Banner';

type Props = {
  onClick: () => void;
  btnClassName?: string;
};

function UpdateAddressBanner({ onClick, btnClassName }: Props): ReactElement {
  return (
    <Banner.Warning
      button={(
        <button
          className={`c-button c-button--secondary ${btnClassName}`}
          type="button"
          onClick={onClick}
        >
          Update Address
        </button>
      )}
    >
      <strong>Please, update your delivery information</strong>
    </Banner.Warning>
  );
}

export default UpdateAddressBanner;
